import { matchPath } from 'react-router-dom';

import { FonctionTypeUserEnum } from './userFunctionsMap';

export const DJ_URL = process.env.REACT_APP_DJ_REDIRECT_URL;

export const ROUTES = {
  HOME: '/',
  BLOCKED_ACCESS: '/blocked-access',
  LOGOUT: '/logout',

  // Dashboard Routes
  DASHBOARD: '/dashboard',
  NEW_DASHBOARD_PARAMETRAGE: '/new-dashboard/parametrage',
  QR_CODE_ASSISTANT: '/qr-code-assistant',

  // External Links
  EXTERNAL_ACCUEIL: `${DJ_URL}/`,
  EXTERNAL_CONFORMITE: `${DJ_URL}/compliance/`,
  EXTERNAL_MY_INFORMATION: `${DJ_URL}/profil/edit`,
  EXTERNAL_MY_SUBSCRIPTIONS: `${DJ_URL}/TODO/`,
  EXTERNAL_CGU: `${DJ_URL}/documents/CGU-22092023.pdf`,
  
  // Payment
  PAYMENT_CHECKOUT: '/payment/checkout',
  PAYMENT_INVOICE: '/payment/invoice',
  
  // Setup module
  SETUP_DASHBOARD: '/setup',
  SETUP_SIMPLIFIED_DASHBOARD: '/setup/dashboard',
  SETUP_TRANSACTION_QUALIFICATION: '/setup/transaction-qualification',
  SETUP_COPRO_AREA: '/setup/copro-area',
  SETUP_ADD_COLLABORATORS: '/setup/add-collaborators',
  SETUP_CONFIGURE_NOTIFICATIONS: '/setup/configure-notifications',
  SETUP_BRANDING: '/setup/branding',
  SETUP_MAIL_CONFIG: '/setup/mail-config',
  SETUP_SENT_MAILS: '/setup/mail-config/sent-mails',
  SETUP_NAF_EXCLUSION: '/setup/naf-exclusion',
  
  // Analyzing module
  ANALYZING_DASHBOARD: '/analyzing',
  ANALYZING_MARKET_VISION: '/analyzing/market-vision',
  ANALYZING_VERIFY_COPROPRIETES: '/analyzing/verify-coproprietes',
  ANALYZING_ADD_COPROPRIETES: '/analyzing/add-coproprietes',
  ANALYZING_ADD_ADDRESSES: '/analyzing/add-addresses',
  // unreferenced routes here to be accessed in the future
  ANALYZING_COPRO_MANAGING: '/analyzing/copro-managing',
  ANALYZING_COPRO_MANAGING_ID: '/analyzing/copro-managing/:coproId',
  ANALYZING_GENERATE_SALES_REPORT: '/analyzing/generate-sales-report', // Should not be referenced as of now
  ANALYZING_COPRO_VIGILANCE: '/analyzing/copro-vigilance', // Should not be referenced as of now
  ANALYZING_GESTIONNAIRES_COPROS: '/analyzing/gestionnaires-copros', // Should not be referenced as of now
  ANALYZING_GENERATE_COPRO_REPORT: '/analyzing/generate-copro-report', // Should not be referenced as of now




  // Communication module
  COMMUNICATION_DASHBOARD: '/communication',
  COMMUNICATION_UNSUBSCRIBERS: '/communication/unsubscribers',
  COMMUNICATION_NEWSLETTER_LIST: '/communication/newsletters/list',
  COMMUNICATION_NEWSLETTER_TEMPLATE_SELECTION: '/communication/newsletters/template-selection',
  COMMUNICATION_NEWSLETTER_PREVIEW: '/communication/newsletters/:id',
  COMMUNICATION_PAGE_SITE: '/communication/page-site',
  COMMUNICATION_REFERENT_CAMPAIGNS: '/communication/referent-campaigns',
  COMMUNICATION_REFERENT_FORMATION: '/communication/referent-formation',
  COMMUNICATION_BUILDING_SALE_BOITAGE: '/communication/building-sale-boitage',
  COMMUNICATION_GENERAL_ASSEMBLY_REFERENT: '/communication/general-assembly-referent',
  COMMUNICATION_GENERAL_ASSEMBLY_MANAGER: '/communication/general-assembly-manager',
  // Referent Module 4: appointments (mocked)
  REFERENT_APPOINTMENTS: '/communication/referent-appointments',
  // Referent Appointments deep links
  REFERENT_APPOINTMENTS_NEW: '/communication/referent-appointments/nouveau-rdv',
  REFERENT_APPOINTMENTS_SCHEDULED: '/communication/referent-appointments/rdv-programmes',
  REFERENT_APPOINTMENTS_TRACKING: '/communication/referent-appointments/suivi-rdv',
  REFERENT_APPOINTMENTS_TEMPLATE_CLIENT: '/communication/referent-appointments/modele-client',
  REFERENT_APPOINTMENTS_TEMPLATE_COLLAB: '/communication/referent-appointments/modele-collaborateur',
  REFERENT_APPOINTMENTS_TEMPLATE_RELANCE: '/communication/referent-appointments/modele-relance',
  REFERENT_APPOINTMENTS_TEAM_SALES: '/communication/referent-appointments/equipe-vente',
  REFERENT_APPOINTMENTS_TEAM_RENTAL: '/communication/referent-appointments/equipe-location',
  REFERENT_APPOINTMENTS_TEAM_PLANNING: '/communication/referent-appointments/planning-equipes',
  
  // Prospection targeted module
  PROSPECTING_DASHBOARD: '/prospecting',
  PROSPECTING_NEW_OPPORTUNITIES: '/prospecting/new-opportunities',
  // PROSPECTING_IDENTIFIED_OWNER: '/prospecting/identified-owner', // TODO: refacto to remove this step
  PROSPECTING_COMMUNICATE: '/prospecting/communicate',
  PROSPECTING_TRANSACTION: '/prospecting/transaction',
  PROSPECTING_RENTAL: '/prospecting/rental',
  PROSPECTING_TEAM_PERFORMANCE: '/prospecting/team-performance',
  PROSPECTING_DPE_VISION: '/prospecting/dpe-vision',
  PROSPECTING_GENERATE_DPE_REPORT: '/prospecting/generate-dpe-report',
  PROSPECTING_COPRO_DETAILED_LIST: '/prospecting/copro-detailed-list',
  PROSPECTING_COPRO_KEY_FIGURES: '/prospecting/copro-key-figures',
  PROSPECTING_BOITAGE_QUALIFICATION: '/prospecting/boitage-qualification',
  PROSPECTING_BOITAGE_TRANSACTION: '/prospecting/boitage-transaction',
  PROSPECTING_SCIS_TRANSACTION: '/prospecting/scis-transaction',
  PROSPECTING_SCIS_RENT: '/prospecting/scis-rent',
  PROSPECTING_SCIS_REFERENT: '/prospecting/scis-referent',
  
  
  // Monitoring module
  MONITORING_DASHBOARD: '/monitoring',
  MONITORING_ENTREPRISES_SUIVIES: '/monitoring/entreprises-suivies',
  MONITORING_BAUX_COMMERCIAUX: '/monitoring/baux-commerciaux',
  MONITORING_BAUX_A_ECHEANCE: '/monitoring/baux-a-echeance',
  MONITORING_BAUX_COMMERCIAUX_COPRO: '/monitoring/baux-commerciaux/:coproId',
  MONITORING_ENTREPRISES_EN_DEFAILLANCE: '/monitoring/entreprises-en-defaillance',
  MONITORING_SCIS: '/monitoring/scis',
  MONITORING_SCIS_SIREN: '/monitoring/scis/:siren',  
  MONITORING_SCIS_OVERALL: '/monitoring/scis-overall',
  MONITORING_INSURANCE_EXCLUSIONS: '/monitoring/insurance-exclusions',
  
  

  // Admin 
  ADMIN_DASHBOARD: '/admin',
  ADMIN_SOFTWARE_IMPORT: '/admin/software-import',
  ADMIN_SCI_CONTACT_IMPORT: '/admin/sci-contact-import',
  ADMIN_IMPORT_HISTORY: '/admin/import-history',
  ADMIN_IMPORT_DETAIL: '/admin/import/:importId',
  ADMIN_COMPANY_VERIFICATION: '/admin/company-verification',
  ADMIN_COPRO_VALIDATION: '/admin/copro-validation/',
  ADMIN_COMPANIES_LIST: '/admin/companies',
  ADMIN_CLIENTS_LIST: '/admin/clients',
  ADMIN_CLIENTS_PLANNING: '/admin/clients-planning',
  ADMIN_CARD_HOLDERS_LIST: '/admin/card-holders',
  ADMIN_COMPANY_DETAILS: '/admin/companies/:companyId',
  ADMIN_SIRET_TRACKED_IMPORT: '/admin/siret-tracked-import',
  ADMIN_BLOG_POSTS: '/admin/blog-posts',
  ADMIN_BLOG_POST_NEW: '/admin/blog-posts/new',
  ADMIN_BLOG_POST_EDIT: '/admin/blog-posts/:id/edit',
  ADMIN_NEWSLETTER: '/admin/newsletter',
  ADMIN_NEWSLETTER_SELECT_TYPE: '/admin/newsletter/new/select-type',
  ADMIN_NEWSLETTER_NEW_STRUCTURED: '/admin/newsletter/new/structured-newsletter',
  ADMIN_NEWSLETTER_EDIT: '/admin/newsletter/:id/edit',
  ADMIN_NEWSLETTER_PREVIEW: '/admin/newsletter/:id/preview',
  ADMIN_PENDING_CONFIG_IMPORTS: '/admin/pending-config-imports',


  // Croissance
  CROISSANCE: '/growth-presentation',

  // External
  EXTERNAL_BLOG: '/blog',
  EXTERNAL_BLOG_POST: '/blog/:slug',
  COMMUNICATION_SCI_UNSUBSCRIBERS: '/communication/sci-unsubscribers',
};

// Routes accessible to freemium members
export const FREEMIUM_ROUTES = [
  // Core routes
  ROUTES.HOME,
  ROUTES.DASHBOARD,
  ROUTES.BLOCKED_ACCESS,
  ROUTES.LOGOUT,

  // Dashboard routes
  ROUTES.NEW_DASHBOARD_PARAMETRAGE,
  ROUTES.QR_CODE_ASSISTANT,

  // External Links
  ROUTES.EXTERNAL_CONFORMITE,
  ROUTES.EXTERNAL_MY_INFORMATION,
  ROUTES.EXTERNAL_MY_SUBSCRIPTIONS,

  // Payment
  ROUTES.PAYMENT_CHECKOUT,
  ROUTES.PAYMENT_INVOICE,

  // Setup module
  ROUTES.SETUP_DASHBOARD,
  ROUTES.SETUP_SIMPLIFIED_DASHBOARD,
  ROUTES.SETUP_BRANDING,
  ROUTES.SETUP_COPRO_AREA,
  // ROUTES.SETUP_ADD_COLLABORATORS,
  // ROUTES.SETUP_CONFIGURE_NOTIFICATIONS,
  // ROUTES.SETUP_COPRO_AREA,
  
  // Analyzing module
  ROUTES.ANALYZING_DASHBOARD,
  ROUTES.ANALYZING_MARKET_VISION,
  ROUTES.ANALYZING_VERIFY_COPROPRIETES,
  ROUTES.ANALYZING_ADD_COPROPRIETES,
  ROUTES.ANALYZING_ADD_ADDRESSES,

  // Communication module
  ROUTES.COMMUNICATION_DASHBOARD,

  // Prospecting module
  ROUTES.PROSPECTING_DASHBOARD,

  // Monitoring module
  ROUTES.MONITORING_DASHBOARD,

  // Croissance
  ROUTES.CROISSANCE,

  // Admin module (for admin freemium access)
  ROUTES.ADMIN_DASHBOARD,
  ROUTES.ADMIN_SOFTWARE_IMPORT,
  ROUTES.ADMIN_SCI_CONTACT_IMPORT,
  ROUTES.ADMIN_IMPORT_HISTORY,
  ROUTES.ADMIN_IMPORT_DETAIL,
  ROUTES.ADMIN_COMPANY_VERIFICATION,
  ROUTES.ADMIN_COPRO_VALIDATION,
  ROUTES.ADMIN_COMPANIES_LIST,
  ROUTES.ADMIN_CLIENTS_LIST,
  ROUTES.ADMIN_CLIENTS_PLANNING,
  ROUTES.ADMIN_COMPANY_DETAILS,
  ROUTES.ADMIN_SIRET_TRACKED_IMPORT,
  ROUTES.ADMIN_BLOG_POSTS,
  ROUTES.ADMIN_BLOG_POST_NEW,
  ROUTES.ADMIN_BLOG_POST_EDIT,
  ROUTES.ADMIN_NEWSLETTER,
  ROUTES.ADMIN_NEWSLETTER_SELECT_TYPE,
  ROUTES.ADMIN_NEWSLETTER_NEW_STRUCTURED,
  ROUTES.ADMIN_NEWSLETTER_EDIT,
  ROUTES.ADMIN_NEWSLETTER_PREVIEW,
  ROUTES.ADMIN_PENDING_CONFIG_IMPORTS,
] as const;

// Routes accessible without authentication (bypass JWT redirect entirely)
export const PUBLIC_ROUTES = [
  ROUTES.CROISSANCE,
] as const;

export const isPublicRoute = (pathname: string): boolean =>
  PUBLIC_ROUTES.some(route => matchPath(route, pathname));

// Setup routes that require paid access to any module
export const SETUP_PAID_ACCESS_ROUTES = [
  ROUTES.SETUP_TRANSACTION_QUALIFICATION,
  ROUTES.SETUP_ADD_COLLABORATORS,
  ROUTES.SETUP_CONFIGURE_NOTIFICATIONS,
] as const;

// Functions allowed to access setup / account configuration pages.
// Anyone outside this set is considered a "standard" user for setup purposes.
export const SETUP_ALLOWED_FUNCTIONS: FonctionTypeUserEnum[] = [
  FonctionTypeUserEnum.REPRESENTANT_LEGAL,
  FonctionTypeUserEnum.RGPD_REFERANT,
  FonctionTypeUserEnum.DIRECTEUR_AGENCE,
  FonctionTypeUserEnum.DIRECTEUR_COMMERCIAL,
];

// Routes that configure the account/company and must be restricted to SETUP_ALLOWED_FUNCTIONS.
export const SETUP_ACCESS_ROUTES: string[] = [
  ROUTES.NEW_DASHBOARD_PARAMETRAGE,
  ROUTES.SETUP_DASHBOARD,
  ROUTES.SETUP_SIMPLIFIED_DASHBOARD,
  ROUTES.SETUP_TRANSACTION_QUALIFICATION,
  ROUTES.SETUP_COPRO_AREA,
  ROUTES.SETUP_ADD_COLLABORATORS,
  ROUTES.SETUP_CONFIGURE_NOTIFICATIONS,
  ROUTES.SETUP_BRANDING,
  ROUTES.SETUP_MAIL_CONFIG,
  ROUTES.SETUP_SENT_MAILS,
  ROUTES.SETUP_NAF_EXCLUSION,
];

/**
 * Whether a user may access setup/account-configuration pages.
 *
 * @param userFonctionTypesInCompany all of the user's fonction types for the active company
 * @param isAdmin whether the user has ROLE_ADMIN
 */
export function canAccessSetup(userFonctionTypesInCompany: number[], isAdmin: boolean): boolean {
  if (isAdmin) {
    return true;
  }
  const allowed: number[] = SETUP_ALLOWED_FUNCTIONS;
  return userFonctionTypesInCompany.some((type) => allowed.includes(type));
}

// Map routes to allowed user functions
export const ROUTE_ACCESS_MAP: { [key: string]: FonctionTypeUserEnum[] } = {
  [ROUTES.SETUP_ADD_COLLABORATORS]: SETUP_ALLOWED_FUNCTIONS,
} as const;
